module.exports = __webpack_public_path__ + "static/media/checkbox.8ef86c94.svg";